<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="editForm"
      label-width="100px"
    >
      <el-form-item
        label="appId"
        prop="appId"
        style="margin-right:15px"
      >
        <el-input
          v-model="editForm.appId"
          placeholder="请输入appId"
        />
      </el-form-item>
      <el-form-item
        label="app名称"
        prop="appName"
        style="margin-right:15px"
      >
        <el-input
          v-model="editForm.appName"
          placeholder="请输入app名称"
          maxlength="50"
        />
      </el-form-item>
      <el-form-item
        label="企业app安全码"
        prop="appSecurity"
        style="margin-right:15px"
      >
        <el-input
          v-model="editForm.appSecurity"
          placeholder="请输入企业app安全码"
          maxlength="128"
        />
      </el-form-item>
      <el-form-item
        label="app类型"
        prop="appType"
        style="margin-right:15px"
      >
        <el-select
          v-model="editForm.appType"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in appTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="parseInt(item.value)"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "PartyGroupConfigAdd",
  data() {
    return {
      emptyForm: {},
      editForm: {
        appId: "",
        appType: "",
        appSecurity: "",
        appName: "",
        code: "",
      },
      appTypeOptions: [
        {
          value: "1",
          label: "安卓",
        },
        {
          value: "2",
          label: "IOS",
        },
      ],
      rules: {
        appId: [
          { required: true, message: "请选择可编辑类型", trigger: "blur" },
        ],
        appType: [
          { required: true, message: "请输入配置类型", trigger: "blur" },
        ],
        appSecurity: [
          { required: true, message: "请输入配置的key", trigger: "blur" },
        ],
        appName: [
          { required: true, message: "请输入配置的value", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.editForm));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.editForm = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/guangdongAppInfo/${code}`,
        method: "get",
      }).then((response) => {
        this.editForm = response.data;
      });
    },
    //提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.editForm;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/guangdongAppInfo",
            method: "put",
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherEditMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}

.el-date-editor {
  width: 100%;
}
</style>

